/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Aleksandr Perkhunov
 * @author Andrey Dubov
 * @version 1.23.0
 * @since 1.0.0
 */
import { createBrowserHistory, LocationState } from 'history';

const appHistory = createBrowserHistory();

export const appHistoryPush = (path: string, state?: LocationState) => {
    appHistory.push(path, state);
};

export default appHistory;
